
export default (function () {
	var eng = false;

	if (process.server) {
		if (process.env['LAN'] === 'en') {
			eng = true;
		}
	} else if (location.host === 'en.pechenyemorozova.ru') {
		eng = true;
	}

	return eng;
});


//////////////////
// WEBPACK FOOTER
// ./plugins/_isEng.js
// module id = ./plugins/_isEng.js
// module chunks = 5